// Mock data for books
export const mockBooks = [
  { 
    id: 1, 
    title: 'Harry Potter and the Philosopher\'s Stone', 
    author: 'J.K. Rowling', 
    price: 15.99,
    rating: 4.8,
    reviews: 12453,
    image: 'https://covers.openlibrary.org/b/id/8267098-L.jpg',
    category: 'Fantasy',
    description: 'The magical journey begins with Harry discovering his wizarding heritage.'
  },
  {
    id: 2,
    title: '1984',
    author: 'George Orwell',
    price: 12.99,
    rating: 4.7,
    reviews: 9876,
    image: 'https://covers.openlibrary.org/b/id/8575785-L.jpg',
    category: 'Dystopian',
    description: 'A dystopian social science fiction novel that follows Winston Smith in a totalitarian future society.'
  },
  {
    id: 3,
    title: 'Pride and Prejudice',
    author: 'Jane Austen',
    price: 9.99,
    rating: 4.6,
    reviews: 8765,
    image: 'https://covers.openlibrary.org/b/id/8739161-L.jpg',
    category: 'Classic',
    description: 'A classic romance novel following Elizabeth Bennet and Mr. Darcy.'
  },
  {
    id: 4,
    title: 'The Hobbit',
    author: 'J.R.R. Tolkien',
    price: 14.99,
    rating: 4.9,
    reviews: 11234,
    image: 'https://covers.openlibrary.org/b/id/8405716-L.jpg',
    category: 'Fantasy',
    description: 'Bilbo Baggins embarks on an unexpected journey with thirteen dwarves.'
  },
  {
    id: 5,
    title: 'Dune',
    author: 'Frank Herbert',
    price: 16.99,
    rating: 4.7,
    reviews: 7654,
    image: 'https://covers.openlibrary.org/b/id/8406427-L.jpg',
    category: 'Sci-Fi',
    description: 'A sweeping sci-fi epic set on the desert planet Arrakis.'
  },
  {
    id: 6,
    title: 'The Alchemist',
    author: 'Paulo Coelho',
    price: 11.99,
    rating: 4.5,
    reviews: 6543,
    image: 'https://covers.openlibrary.org/b/id/8705156-L.jpg',
    category: 'Fiction',
    description: 'A mystical story about following your dreams and finding your destiny.'
  },
  {
    id: 7,
    title: 'Atomic Habits',
    author: 'James Clear',
    price: 18.99,
    rating: 4.8,
    reviews: 5432,
    image: 'https://covers.openlibrary.org/b/id/12547242-L.jpg',
    category: 'Self-Help',
    description: 'A proven framework for improving every day through tiny changes.'
  },
  {
    id: 8,
    title: 'The Da Vinci Code',
    author: 'Dan Brown',
    price: 13.99,
    rating: 4.4,
    reviews: 9876,
    image: 'https://covers.openlibrary.org/b/id/8743330-L.jpg',
    category: 'Thriller',
    description: 'A thrilling mystery involving art, religion, and ancient secrets.'
  },
  {
    id: 9,
    title: 'The Great Gatsby',
    author: 'F. Scott Fitzgerald',
    price: 10.99,
    rating: 4.5,
    reviews: 7654,
    image: 'https://covers.openlibrary.org/b/id/8411838-L.jpg',
    category: 'Classic',
    description: 'A story of decadence and excess in the Jazz Age.'
  },
  {
    id: 10,
    title: 'Educated',
    author: 'Tara Westover',
    price: 15.99,
    rating: 4.7,
    reviews: 4321,
    image: 'https://covers.openlibrary.org/b/id/8740897-L.jpg',
    category: 'Memoir',
    description: 'A memoir about a woman who leaves her survivalist family for education.'
  },
  {
    id: 11,
    title: 'The Silent Patient',
    author: 'Alex Michaelides',
    price: 14.99,
    rating: 4.6,
    reviews: 5678,
    image: 'https://covers.openlibrary.org/b/id/10389354-L.jpg',
    category: 'Thriller',
    description: 'A psychological thriller about a woman who stops speaking after shooting her husband.'
  },
  {
    id: 12,
    title: 'Project Hail Mary',
    author: 'Andy Weir',
    price: 17.99,
    rating: 4.8,
    reviews: 3456,
    image: 'https://covers.openlibrary.org/b/id/10389354-L.jpg',
    category: 'Sci-Fi',
    description: 'An astronaut wakes up alone on a spaceship with no memory of how he got there.'
  },
  {
    id: 13,
    title: 'The Midnight Library',
    author: 'Matt Haig',
    price: 13.99,
    rating: 4.5,
    reviews: 4567,
    image: 'https://covers.openlibrary.org/b/id/10389354-L.jpg',
    category: 'Fiction',
    description: 'A story about a library between life and death, and the infinite possibilities of life.'
  },
  {
    id: 14,
    title: 'Sapiens',
    author: 'Yuval Noah Harari',
    price: 16.99,
    rating: 4.7,
    reviews: 8765,
    image: 'https://covers.openlibrary.org/b/id/7398229-L.jpg',
    category: 'Non-Fiction',
    description: 'A brief history of humankind, from ancient humans to modern civilization.'
  },
  {
    id: 15,
    title: 'The Name of the Wind',
    author: 'Patrick Rothfuss',
    price: 15.99,
    rating: 4.9,
    reviews: 6789,
    image: 'https://covers.openlibrary.org/b/id/8259383-L.jpg',
    category: 'Fantasy',
    description: 'The tale of a young man who becomes the most notorious wizard his world has ever seen.'
  },
  // Adding 25 more books with similar structure but different titles/authors
  {
    id: 16,
    title: 'The Way of Kings',
    author: 'Brandon Sanderson',
    price: 19.99,
    rating: 4.8,
    reviews: 7890,
    image: 'https://covers.openlibrary.org/b/id/8474593-L.jpg',
    category: 'Fantasy',
    description: 'An epic fantasy series about war, honor, and magical powers called Surgebinding.'
  },
  {
    id: 17,
    title: 'The Seven Husbands of Evelyn Hugo',
    author: 'Taylor Jenkins Reid',
    price: 13.99,
    rating: 4.7,
    reviews: 5678,
    image: 'https://covers.openlibrary.org/b/id/12547243-L.jpg',
    category: 'Historical Fiction',
    description: 'A Hollywood legend recounts her life story and her seven marriages.'
  },
  {
    id: 18,
    title: 'The Psychology of Money',
    author: 'Morgan Housel',
    price: 15.99,
    rating: 4.6,
    reviews: 4321,
    image: 'https://covers.openlibrary.org/b/id/10312351-L.jpg',
    category: 'Self-Help',
    description: 'Timeless lessons on wealth, greed, and happiness.'
  },
  {
    id: 19,
    title: 'Verity',
    author: 'Colleen Hoover',
    price: 12.99,
    rating: 4.5,
    reviews: 6789,
    image: 'https://covers.openlibrary.org/b/id/12547244-L.jpg',
    category: 'Thriller',
    description: 'A writer discovers disturbing truths while completing another author\'s manuscript.'
  },
  {
    id: 20,
    title: 'Foundation',
    author: 'Isaac Asimov',
    price: 14.99,
    rating: 4.7,
    reviews: 5432,
    image: 'https://covers.openlibrary.org/b/id/8474594-L.jpg',
    category: 'Sci-Fi',
    description: 'A mathematician predicts the fall of a galactic empire and plans to preserve knowledge.'
  },
  {
    id: 21,
    title: 'The Song of Achilles',
    author: 'Madeline Miller',
    price: 13.99,
    rating: 4.8,
    reviews: 4567,
    image: 'https://covers.openlibrary.org/b/id/8474595-L.jpg',
    category: 'Historical Fiction',
    description: 'A retelling of the Iliad from Patroclus\'s perspective.'
  },
  {
    id: 22,
    title: 'Think Like a Monk',
    author: 'Jay Shetty',
    price: 16.99,
    rating: 4.6,
    reviews: 3456,
    image: 'https://covers.openlibrary.org/b/id/10312352-L.jpg',
    category: 'Self-Help',
    description: 'Train your mind for peace and purpose every day.'
  },
  {
    id: 23,
    title: 'A Court of Thorns and Roses',
    author: 'Sarah J. Maas',
    price: 14.99,
    rating: 4.7,
    reviews: 7890,
    image: 'https://covers.openlibrary.org/b/id/8474596-L.jpg',
    category: 'Fantasy',
    description: 'A mortal huntress is drawn into a dangerous faerie realm.'
  },
  {
    id: 24,
    title: 'The Thursday Murder Club',
    author: 'Richard Osman',
    price: 13.99,
    rating: 4.5,
    reviews: 4321,
    image: 'https://covers.openlibrary.org/b/id/12547245-L.jpg',
    category: 'Mystery',
    description: 'Four retirees meet weekly to solve cold cases.'
  },
  {
    id: 25,
    title: 'The Martian',
    author: 'Andy Weir',
    price: 14.99,
    rating: 4.8,
    reviews: 8765,
    image: 'https://covers.openlibrary.org/b/id/8474597-L.jpg',
    category: 'Sci-Fi',
    description: 'An astronaut struggles to survive alone on Mars.'
  },
  {
    id: 26,
    title: 'The House in the Cerulean Sea',
    author: 'TJ Klune',
    price: 15.99,
    rating: 4.9,
    reviews: 5678,
    image: 'https://covers.openlibrary.org/b/id/10312353-L.jpg',
    category: 'Fantasy',
    description: 'A caseworker visits a magical orphanage and finds unexpected joy.'
  },
  {
    id: 27,
    title: 'The Subtle Art of Not Giving a F*ck',
    author: 'Mark Manson',
    price: 14.99,
    rating: 4.5,
    reviews: 9876,
    image: 'https://covers.openlibrary.org/b/id/8474598-L.jpg',
    category: 'Self-Help',
    description: 'A counterintuitive approach to living a good life.'
  },
  {
    id: 28,
    title: 'Mexican Gothic',
    author: 'Silvia Moreno-Garcia',
    price: 13.99,
    rating: 4.6,
    reviews: 4567,
    image: 'https://covers.openlibrary.org/b/id/10312354-L.jpg',
    category: 'Horror',
    description: 'A young woman investigates her cousin\'s claims of supernatural horrors.'
  },
  {
    id: 29,
    title: 'The Hitchhiker\'s Guide to the Galaxy',
    author: 'Douglas Adams',
    price: 12.99,
    rating: 4.8,
    reviews: 7654,
    image: 'https://covers.openlibrary.org/b/id/8474599-L.jpg',
    category: 'Sci-Fi',
    description: 'The misadventures of Arthur Dent through space.'
  },
  {
    id: 30,
    title: 'The Vanishing Half',
    author: 'Brit Bennett',
    price: 15.99,
    rating: 4.7,
    reviews: 6543,
    image: 'https://covers.openlibrary.org/b/id/10312355-L.jpg',
    category: 'Fiction',
    description: 'Twin sisters choose to live in two very different worlds.'
  },
  {
    id: 31,
    title: 'The Four Winds',
    author: 'Kristin Hannah',
    price: 16.99,
    rating: 4.6,
    reviews: 5432,
    image: 'https://covers.openlibrary.org/b/id/12547246-L.jpg',
    category: 'Historical Fiction',
    description: 'A woman struggles to keep her family alive during the Dust Bowl.'
  },
  {
    id: 32,
    title: 'Klara and the Sun',
    author: 'Kazuo Ishiguro',
    price: 14.99,
    rating: 4.5,
    reviews: 4321,
    image: 'https://covers.openlibrary.org/b/id/10312356-L.jpg',
    category: 'Sci-Fi',
    description: 'An Artificial Friend observes the world and human nature.'
  },
  {
    id: 33,
    title: 'The Midnight Rose',
    author: 'Lucinda Riley',
    price: 13.99,
    rating: 4.6,
    reviews: 3456,
    image: 'https://covers.openlibrary.org/b/id/12547247-L.jpg',
    category: 'Historical Fiction',
    description: 'A multi-generational story spanning from India to England.'
  },
  {
    id: 34,
    title: 'The Guest List',
    author: 'Lucy Foley',
    price: 12.99,
    rating: 4.4,
    reviews: 5678,
    image: 'https://covers.openlibrary.org/b/id/10312357-L.jpg',
    category: 'Mystery',
    description: 'A wedding celebration turns dark when someone turns up dead.'
  },
  {
    id: 35,
    title: 'The Priory of the Orange Tree',
    author: 'Samantha Shannon',
    price: 18.99,
    rating: 4.7,
    reviews: 4567,
    image: 'https://covers.openlibrary.org/b/id/12547248-L.jpg',
    category: 'Fantasy',
    description: 'An epic fantasy about dragons, queens, and ancient magic.'
  },
  {
    id: 36,
    title: 'Circe',
    author: 'Madeline Miller',
    price: 14.99,
    rating: 4.8,
    reviews: 6789,
    image: 'https://covers.openlibrary.org/b/id/8474600-L.jpg',
    category: 'Fantasy',
    description: 'A bold retelling of the story of the mythological witch Circe.'
  },
  {
    id: 37,
    title: 'The Last Thing He Told Me',
    author: 'Laura Dave',
    price: 13.99,
    rating: 4.5,
    reviews: 4321,
    image: 'https://covers.openlibrary.org/b/id/12547249-L.jpg',
    category: 'Mystery',
    description: 'A woman searches for the truth about her missing husband.'
  },
  {
    id: 38,
    title: 'The Paris Library',
    author: 'Janet Skeslien Charles',
    price: 15.99,
    rating: 4.6,
    reviews: 3456,
    image: 'https://covers.openlibrary.org/b/id/10312358-L.jpg',
    category: 'Historical Fiction',
    description: 'Based on the true story of the American Library in Paris during WWII.'
  },
  {
    id: 39,
    title: 'The Invisible Life of Addie LaRue',
    author: 'V.E. Schwab',
    price: 14.99,
    rating: 4.8,
    reviews: 7890,
    image: 'https://covers.openlibrary.org/b/id/10312359-L.jpg',
    category: 'Fantasy',
    description: 'A woman makes a Faustian bargain to live forever but is cursed to be forgotten.'
  },
  {
    id: 40,
    title: 'The Invisible Life of Addie LaRue',
    author: 'V.E. Schwab',
    price: 14.99,
    rating: 4.6,
    reviews: 4567,
    image: 'https://covers.openlibrary.org/b/id/10312350-L.jpg',
    category: 'Fantasy',
    description: 'A woman makes a Faustian bargain to live forever but is cursed to be forgotten by everyone she meets.'
  },
  {
    id: 41,
    title: 'Beach Read',
    author: 'Emily Henry',
    price: 13.99,
    rating: 4.5,
    reviews: 3890,
    image: 'https://covers.openlibrary.org/b/id/10389355-L.jpg',
    category: 'Romance',
    description: 'A romance writer and a literary fiction author swap genres for a summer.'
  },
  {
    id: 42,
    title: 'The Love Hypothesis',
    author: 'Ali Hazelwood',
    price: 14.99,
    rating: 4.7,
    reviews: 5678,
    image: 'https://covers.openlibrary.org/b/id/12547250-L.jpg',
    category: 'Romance',
    description: 'A Ph.D. candidate finds herself in a fake relationship with a young professor.'
  },
  {
    id: 43,
    title: 'People We Meet on Vacation',
    author: 'Emily Henry',
    price: 13.99,
    rating: 4.6,
    reviews: 4567,
    image: 'https://covers.openlibrary.org/b/id/10389356-L.jpg',
    category: 'Romance',
    description: 'Two best friends take one last vacation together to fix their relationship.'
  },
  {
    id: 44,
    title: 'Red, White & Royal Blue',
    author: 'Casey McQuiston',
    price: 14.99,
    rating: 4.8,
    reviews: 6789,
    image: 'https://covers.openlibrary.org/b/id/12547251-L.jpg',
    category: 'Romance',
    description: 'The First Son falls in love with the Prince of Wales.'
  },
  {
    id: 45,
    title: 'Born a Crime',
    author: 'Trevor Noah',
    price: 15.99,
    rating: 4.9,
    reviews: 7890,
    image: 'https://covers.openlibrary.org/b/id/8474601-L.jpg',
    category: 'Memoir',
    description: 'Trevor Noah\'s journey from apartheid South Africa to host of The Daily Show.'
  },
  {
    id: 46,
    title: 'Know My Name',
    author: 'Chanel Miller',
    price: 16.99,
    rating: 4.8,
    reviews: 4567,
    image: 'https://covers.openlibrary.org/b/id/10389357-L.jpg',
    category: 'Memoir',
    description: 'A powerful memoir about trauma, healing, and the pursuit of justice.'
  },
  {
    id: 47,
    title: 'The Glass Castle',
    author: 'Jeannette Walls',
    price: 13.99,
    rating: 4.7,
    reviews: 8901,
    image: 'https://covers.openlibrary.org/b/id/8474602-L.jpg',
    category: 'Memoir',
    description: 'A remarkable memoir of resilience and redemption in a dysfunctional family.'
  },
  {
    id: 48,
    title: 'When Breath Becomes Air',
    author: 'Paul Kalanithi',
    price: 14.99,
    rating: 4.8,
    reviews: 6789,
    image: 'https://covers.openlibrary.org/b/id/8474603-L.jpg',
    category: 'Memoir',
    description: 'A neurosurgeon reflects on life as he faces terminal cancer.'
  },
  {
    id: 49,
    title: 'Tomorrow, and Tomorrow, and Tomorrow',
    author: 'Gabrielle Zevin',
    price: 16.99,
    rating: 4.7,
    reviews: 5678,
    image: 'https://covers.openlibrary.org/b/id/12547252-L.jpg',
    category: 'Fiction',
    description: 'A story about friendship, love, and video game design spanning thirty years.'
  },
  {
    id: 50,
    title: 'Lessons in Chemistry',
    author: 'Bonnie Garmus',
    price: 15.99,
    rating: 4.8,
    reviews: 6789,
    image: 'https://covers.openlibrary.org/b/id/12547253-L.jpg',
    category: 'Fiction',
    description: 'A female chemist becomes a cooking show host in the 1960s.'
  },
  {
    id: 51,
    title: 'Cloud Cuckoo Land',
    author: 'Anthony Doerr',
    price: 17.99,
    rating: 4.6,
    reviews: 4567,
    image: 'https://covers.openlibrary.org/b/id/12547254-L.jpg',
    category: 'Fiction',
    description: 'Interconnected stories across centuries linked by an ancient text.'
  },
  {
    id: 52,
    title: 'The Heart\'s Invisible Furies',
    author: 'John Boyne',
    price: 15.99,
    rating: 4.8,
    reviews: 5678,
    image: 'https://covers.openlibrary.org/b/id/12547255-L.jpg',
    category: 'Fiction',
    description: 'The life journey of an adopted boy in Ireland over seventy years.'
  },
  {
    id: 53,
    title: 'The Seven Husbands of Evelyn Hugo',
    author: 'Taylor Jenkins Reid',
    price: 14.99,
    rating: 4.9,
    reviews: 7890,
    image: 'https://covers.openlibrary.org/b/id/12547256-L.jpg',
    category: 'Fiction',
    description: 'A reclusive Hollywood legend reveals her life story to an unknown journalist.'
  },
  {
    id: 54,
    title: 'Book Lovers',
    author: 'Emily Henry',
    price: 13.99,
    rating: 4.7,
    reviews: 4567,
    image: 'https://covers.openlibrary.org/b/id/12547257-L.jpg',
    category: 'Romance',
    description: 'A literary agent and editor find love in a small town.'
  },
  {
    id: 55,
    title: 'In the Dream House',
    author: 'Carmen Maria Machado',
    price: 15.99,
    rating: 4.8,
    reviews: 3456,
    image: 'https://covers.openlibrary.org/b/id/12547258-L.jpg',
    category: 'Memoir',
    description: 'An innovative memoir about domestic abuse and queer relationships.'
  },
  {
    id: 56,
    title: 'Beautiful World, Where Are You',
    author: 'Sally Rooney',
    price: 14.99,
    rating: 4.5,
    reviews: 5678,
    image: 'https://covers.openlibrary.org/b/id/12547259-L.jpg',
    category: 'Fiction',
    description: 'Four young people navigate love, friendship, and life in Ireland.'
  },
  {
    id: 57,
    title: 'The Kiss Quotient',
    author: 'Helen Hoang',
    price: 13.99,
    rating: 4.6,
    reviews: 4567,
    image: 'https://covers.openlibrary.org/b/id/12547260-L.jpg',
    category: 'Romance',
    description: 'A woman with Asperger\'s hires a male escort to teach her about relationships.'
  },
  {
    id: 58,
    title: 'Greenlights',
    author: 'Matthew McConaughey',
    price: 16.99,
    rating: 4.7,
    reviews: 6789,
    image: 'https://covers.openlibrary.org/b/id/12547261-L.jpg',
    category: 'Memoir',
    description: 'The actor shares his unconventional wisdom and life experiences.'
  },
  {
    id: 59,
    title: 'One Italian Summer',
    author: 'Rebecca Serle',
    price: 14.99,
    rating: 4.5,
    reviews: 3456,
    image: 'https://covers.openlibrary.org/b/id/12547262-L.jpg',
    category: 'Fiction',
    description: 'A magical story about a woman who meets her mother\'s younger self in Italy.'
  },
  {
    id: 60,
    title: 'Love and Other Words',
    author: 'Christina Lauren',
    price: 13.99,
    rating: 4.7,
    reviews: 4567,
    image: 'https://covers.openlibrary.org/b/id/12547263-L.jpg',
    category: 'Romance',
    description: 'Childhood friends reconnect and explore their past and present feelings.'
  }
];

export const categories = [
  'All', 
  'Fantasy', 
  'Classic', 
  'Dystopian', 
  'Romance', 
  'Sci-Fi', 
  'Self-Help', 
  'Fiction', 
  'Non-Fiction', 
  'Thriller', 
  'Memoir', 
  'Historical Fiction'
];
